export default [
    {
      title: 'menu.Home',
      icon: 'HomeIcon',
      tagVariant: 'light-warning',
      route: 'home'
    },
  ]
  